import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getKnowledgeAuthList, getKnowledgeCatalogueList } from '@/views/manageCenter/api';
import { delOrganizeWorkItem, getKnowCategoryResponderList, getOrganizeWorkDetail } from '@/api/directoryManagement';
import { createFeedback, getArtilleryRadar, createEvaluationFeedback } from '@/views/downLoadCenter/api/api';
import FeedbackDialog from '@/views/downLoadCenter/feedbackDialog.vue';
import MyFeedbackList from '@/views/downLoadCenter/myFeedbackList.vue';
export default {
  name: 'functionalDivisionList',
  components: {
    FeedbackDialog: FeedbackDialog,
    MyFeedbackList: MyFeedbackList
  },
  data: function data() {
    return {
      form: {
        keyword: '',
        category_id: '',
        organize_id: '',
        first_responder_id: '',
        second_responder_id: '',
        page: 1,
        page_size: 50
      },
      dataList: [],
      pages: {},
      userList: [],
      options: [],
      category: [],
      dialogTitle: '',
      dialogVisible: false,
      addForm: {
        feedback_content: ''
      },
      type: 'add',
      subMitLoading: false,
      drawer: false,
      myFeedbackListVisible: false
    };
  },
  created: function created() {
    this.getUserList();
    this.getOrganizeList();
    this.getCategoryList();
    this.getDate();
  },
  methods: {
    getDate: function getDate() {
      var _this = this;
      var params = _objectSpread({}, this.form);
      if (this.$refs.organize) {
        params.organize_id = this.$refs.organize.getCheckedNodes(false, true).map(function (res) {
          return res.value;
        });
      }
      getArtilleryRadar(params).then(function (res) {
        _this.dataList = res.data.list;
        _this.pages = res.pages;
      });
    },
    handleFeedback: function handleFeedback() {
      var event = this.$refs.feedbackDialog;
      event.dialogVisible = true;
    },
    // 评价明细
    evaluateDetails: function evaluateDetails(row) {
      var _this2 = this;
      this.$confirm('此内容是我想要的', '内容有效反馈', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        createEvaluationFeedback({
          item_id: row.id
        }).then(function (res) {
          _this2.getDate();
          _this2.$message({
            type: 'success',
            message: '操作成功!'
          });
        });
      });
    },
    getSearch: function getSearch() {
      this.form.page = 1;
      this.getDate();
    },
    sizeChange: function sizeChange(size) {
      this.form.page_size = size;
      this.getDate();
    },
    currentChange: function currentChange(current) {
      this.form.page = current;
      this.getDate();
    },
    getCategoryList: function getCategoryList() {
      var _this3 = this;
      getKnowCategoryResponderList().then(function (res) {
        _this3.category = res.data.tree;
      });
    },
    getOrganizeList: function getOrganizeList() {
      var _this4 = this;
      var params = {
        id: ''
      };
      getKnowledgeAuthList(params).then(function (res) {
        _this4.options = res.data.tree;
      });
    },
    // 人员数据
    getUserList: function getUserList() {
      var _this5 = this;
      getKnowledgeCatalogueList().then(function (res) {
        _this5.userList = res.data;
      });
    }
  }
};